export default __webpack_public_path__ + "static/media/Sesame.89347bf2.jpg";